define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"csi",
	"csi/_base/underscore",
	"csi/config",
	"csi/def",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/def/AddPath",
	"csi/def/Relationship",
	"csi/form/Widget",
	"csi/locale",
	"csi/store/_base",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Query",
	"csi/xml/Search",
	"./SupplierRequestFormMixin",
], function(declare, lang, Memory, csi, _, config, def, Action, ViewRef, AddPath, Relationship, Widget, locale, csiStore, Names, xml, Query, Search, SupplierRequestFormMixin) {

	return declare([Widget, SupplierRequestFormMixin], {

		PRODUCTS: "Styles",
		SR_MASTER_TYPE: "SupplierRequestMaster",
		CREATE_OPTION: "CreateOption",
		SR_MASTER: "SRMaster",
		SR_MASTER_NAME: "SRMasterName",
		UPDATE_EXISTING_SUPPLIER_REQUESTS: "UpdateExistingSupplierRequests",

		isFromHierarchy: false,

		// C8Node: SRM node if the action is inside a SRM - sent from NewAllocatedSupplierRequests.js
		srMaster: null,

		// Use to remember the value of UpdateExistingSupplierRequests in case the user disable it.
		updateExistingSupplierRequestsEnabledValue: true,

		// Get the product type for the productField by removing the last element(s)
		_productType: function() {
			return this.PRODUCTS.slice(0, -1);
		},

		/** @override */
		_resolveView: function() {

			// set here as this action uses a react view and and onCreatePopup is not called
			const source = this.getFormData().getSource();
			this.PRODUCTS = source.productField;
			source.setSupplierRequestDefaults(this);

			this.insertFieldIfNotExist(this.PRODUCTS, 3, {
				m_typeControl: def.FIELD_MULTI_SELECT,
				m_onChange: "_onChangeProducts",
			});

			this.insertFieldIfNotExist(this.SUPPLIERS, 4, {
				m_typeControl: def.FIELD_MULTI_SELECT,
				m_onChange: "_onChangeSuppliersOrFactories",
				m_bRequired: true,
				omitFromReport: true,
			});
			this.insertFieldIfNotExist(this.SUPPLIER_FACTORIES, 4, {
				m_onChange: "_onChangeSuppliersOrFactories",
				m_bRequired: true,
				// prevent the Form for triggering add/remove SupplierFactories operation from the aggregateStore
				omitFromReport: true,
			});
			this.insertFieldIfNotExist(this.UPDATE_EXISTING_SUPPLIER_REQUESTS, 6, {
				m_typeControl: def.FIELD_CHECKBOX,
				// prevent the Form for triggering add/remove SupplierFactories operation from the aggregateStore
				omitFromReport: true,
			});

			this.inherited(arguments);
			//Set right widget class to null to avoid the right widget from being displayed
			this.rightWidgetClass = null;

			if (this.isNew()) {
				this.insertFieldIfNotExist(this.SR_MASTER_NAME, this.SUBTYPE, {
					m_label: this.SR_MASTER_NAME,
					m_bRequired: true,
					omitFromReport: true
				});
				this.insertFieldIfNotExist(this.SR_MASTER, this.SUBTYPE, {
					m_label: this.SR_MASTER,
					m_typeControl: def.FIELD_FILTERING_SELECT,
					m_bRequired: true,
					m_onChange: "_onChangeSRMaster",
				});

				this.insertFieldIfNotExist(this.CREATE_OPTION, this.SR_MASTER_NAME, {
					m_label: this.CREATE_OPTION,
					m_typeControl: def.FIELD_FILTERING_SELECT,
					m_type: xml.ATTR_STRING,
					m_bRequired: true,
					m_onChange: "_onChangeCreateOption",
				});
				this.addDefaultValue(this.CREATE_OPTION, "0");
			}
		},

		/** 
		 * @override
		 * Set SR_MASTER field to hidden by default if not being created inside a SRMaster
		 * Otherwise, set SR_MASTER_NAME and CREATE_OPTION to hidden and set Subtype and Template to disabled
		*/
		_buildView: function() {
			this.inherited(arguments);

			if (this.srMaster) {
				this.setFieldHidden(this.SR_MASTER_NAME, true);
				this.setFieldHidden(this.CREATE_OPTION, true);
				this.setFieldDisabled(this.SR_MASTER, true);
				this.setFieldValue(this.SR_MASTER, this.srMaster);
			} else {
				this.setFieldHidden(this.SR_MASTER, true);
			}
			if (this.getFixedValue(this.PRODUCTS)) {
				this.setFieldHidden(this.UPDATE_EXISTING_SUPPLIER_REQUESTS, true);
			} else {
				this.setFieldDisabled(this.UPDATE_EXISTING_SUPPLIER_REQUESTS, true);
			}
		},

		/**
		 * @override
		 * Set SR name as not required
		 */
		_updateFieldVisibility: function(field) {
			this.inherited(arguments);
			this.setFieldRequired(xml.ATTR_NAME, false);
			return true;
		},

		/** 
		 * @override 
		 * Set Creation Option/ SR Master Store 
		*/
		getFieldStore(/*Field*/field, /*String*/value) {
			switch (field.getControlName()) {
				case this.CREATE_OPTION:
					return new Memory({
						data: [
							{id: "0", name: locale.resource("CreateOption_New")},
							{id: "1", name: locale.resource("CreateOption_Existing")}
						]
					});
				case this.SR_MASTER:
					if (this.srMaster) { // Is being created inside a SRMaster
						return new Names({
							data: [csiStore.nameObject(this.srMaster)],
						});
					} else {
						const contextUrl = this.defView.getSource().m_urlParent;
						const contextNode = this.cacheView.getNode(contextUrl);
						const pathsToAdd = this.getSRMasterAddPathsByHierarchy(contextNode);
						const productType = this._productType();
						const rel = lang.mixin(new Relationship(), {
							m_typeNode: this.SR_MASTER_TYPE,
							m_addPaths: pathsToAdd,
							m_sorts: [{id: xml.ATTR_NAME}],
							m_url: contextUrl,
							m_query: new Query().Attr("RequestType", xml.OP_EQUALS, `DataPackageContainerType:${productType}`)
						});

						const storeOptions = csiStore.namesOptionsByRelationship(this.getContext(), rel);
						storeOptions.action = lang.mixin(new Action(), {
							m_viewRef: lang.mixin(new ViewRef(), {
								m_id: this.getSupplierRequestsMasterViewId(contextNode, productType),
								m_url: contextUrl
							}),
						});
						return new Names(storeOptions);
					}
				default:
					return this.inherited(arguments);
			}
		},

		/**
		 * Get SupplierRequestsMaster viewId based on contextNode and productType
		 * @param {C8Node} contextNode
		 * @param {string} productType
		 */
		getSupplierRequestsMasterViewId(contextNode, productType) {
			let viewId = "SupplierRequestMasters"
			switch (productType) {
				case "Material":
					if (contextNode.$URL === "centric://APPAREL/Views") {
						viewId = productType + viewId;
					}
					break;
				default:
					break;
			};
			return viewId;
		},

		/**
		 * Get necessary paths to add to SRMaster relationship base on the context node
		 * @param {C8Node} contextNode 
		 */
		getSRMasterAddPathsByHierarchy(contextNode) {
			const pathsToAdd = [];
			if (this.isFromHierarchy) {
				const hierarchyLevel = contextNode.$Type === "Season" ? "ParentSeason" : contextNode.$Type;
				pathsToAdd.push(lang.mixin(new AddPath(), {
					m_path: `Parent:SRM${contextNode.$Type}`
				}));
				pathsToAdd.push(lang.mixin(new AddPath(), {
					m_path: `Parent:${hierarchyLevel}/Parent:SRMProducts`
				}));
			} else if (contextNode.$Type === "MaterialSecurityGroup") {
				pathsToAdd.push(lang.mixin(new AddPath(), {
					m_path: "Parent:MaterialSecurityGroups/Parent:SRLineItemProduct/Child:__Parent__/Child:__Parent__"
				}));
				pathsToAdd.push(lang.mixin(new AddPath(), {
					m_path: "Parent:SRMMaterialSecurityGroup"
				}));
			} else if (contextNode.$Type !== "_CS_ApparelViews") {
				pathsToAdd.push(lang.mixin(new AddPath(), {
					m_path: "Parent:SRMProducts"
				}));
			}
			return pathsToAdd;
		},

		/**
		 * @override
		 * Set SRLineItemProduct on a fake new SRLineItem for aggregateStore filtering
		 */
		onWriteFormReport(field, writer, formInfo) {
			const {nodeUrl} = formInfo;
			let srMasterUrl = csi.EMPTY_URL;
			if (this.isFieldVisible(this.SR_MASTER)) {
				srMasterUrl = this.getFieldValue(this.SR_MASTER);
			}
			writer.changeNode(nodeUrl)
				.publishAttribute("IsAllocatedSR", xml.ATTR_BOOLEAN, true);
			writer.changeNode(nodeUrl)
				.publishAttribute("SRMaster", xml.ATTR_REF, srMasterUrl);
			writer.changeNode(nodeUrl)
				.publishAttribute("Products", xml.ATTR_REFLIST, this.getFieldValue(this.PRODUCTS));
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Reset Supplier or SupplierFactories field store and value.
		 */
		_onChangeProducts: function(/*csi.form.View*/formView, /*csi.def.Field*/f, /*Any*/value) {
			this.resetSourceFieldStoreAndValue();
			this.handleUpdateExistingSupplierRequests(value);
		},

		/**
		 * Reset Supplier or SupplierFactories field store and value.
		 */
		resetSourceFieldStoreAndValue() {
			let sourceFiled = null;
			if (this.isFieldVisible(this.SUPPLIERS) && this.getField(this.SUPPLIERS)) {
				sourceFiled = this.getField(this.SUPPLIERS);
			} else if (this.isFieldVisible(this.SUPPLIER_FACTORIES) && this.getField(this.SUPPLIER_FACTORIES)) {
				sourceFiled = this.getField(this.SUPPLIER_FACTORIES);
			}
			if (sourceFiled) {
				this.resetFieldStoreAndValue(sourceFiled);
				this.setFieldValue(sourceFiled, null);
			}
		},

		/**
		 * Enable UpdateExistingSupplierRequests field if SRMaster is selected and there are styles selected
		 */
		handleUpdateExistingSupplierRequests(value) {
			if (value?.length > 0 && !this.getFixedValue(this.PRODUCTS)
				&& this.isFieldVisible(this.SR_MASTER) && (this.srMaster || xml.isValidURL(this.getFieldValue(this.SR_MASTER)))) {
				this.setFieldDisabled(this.UPDATE_EXISTING_SUPPLIER_REQUESTS, false);
				this.setFieldValue(this.UPDATE_EXISTING_SUPPLIER_REQUESTS, this.updateExistingSupplierRequestsEnabledValue);
			} else {
				this.disableUpdateExistingSR();
			}
		},

		/** Show SRM input field or dropdown if selection is create under a New or Existing SRM */
		_onChangeCreateOption: function(/*def.View*/formView, /*Field*/field, /*Any*/value) {
			if (value === "0") {
				this.setFieldHidden(this.SR_MASTER, true);
				this.setFieldHidden(this.SR_MASTER_NAME, false);
				this.setFieldDisabled(this.SUBTYPE, false);
				this.setFieldDisabled(this.TEMPLATE, false);
				this.resetFieldStoreAndValue(this.SUBTYPE);
				this.TEMPLATE_VALUE = csi.EMPTY_URL;
				this.disableUpdateExistingSR();
				this.srMaster = null;
				this.setFieldValuesFromSRMaster(this.srMaster);
			} else {
				this.setFieldHidden(this.SR_MASTER, false);
				this.setFieldHidden(this.SR_MASTER_NAME, true);
				const master = this.getCache().getNode(this.getFieldValue(this.SR_MASTER));
				this.setFieldValuesFromSRMaster(master);
			}
		},

		/** Set SR Master values for Subtype, SRTemplate and DataPackageTemplate */
		_onChangeSRMaster: function(/*def.View*/formView, /*Field*/field, /*Any*/value) {
			const createNew = this.getFieldValue(this.CREATE_OPTION);
			if (createNew === "1" || this.srMaster) {
				this.srMaster = this.getCache().getNode(value);
				this.setFieldValuesFromSRMaster(this.srMaster);
			}
		},

		/** Set SR Master values for Subtype, SRTemplate and DataPackageTemplate
		 * @param {Object} master - SRMaster node
		 */
		setFieldValuesFromSRMaster(master) {
			if (!this.getFixedValue(this.PRODUCTS)) {
				this.resetFieldStoreAndValue(this.PRODUCTS, master?.SRMProducts);
			}
			if (master) {
				this.setFieldValue(this.SUBTYPE, master.SRSubtype);
				this.setFieldDisabled(this.SUBTYPE, true);
				this.TEMPLATE_VALUE = master.SRMSupplierRequestTemplate;
				this.setFieldValue(this.TEMPLATE, this.TEMPLATE_VALUE);
				if (xml.isValidURL(this.TEMPLATE_VALUE) || master.SRMSupplierRequests.length > 0) {
					this.setFieldDisabled(this.TEMPLATE, true);
				}
				this.resetSourceFieldStoreAndValue();
				this.disableUpdateExistingSR();
			}
		},

		/**
		 * @override
		 * Set query filter for hierarchy level when creating a new SR under a SRM
		 */
		setProductStoreHierarchyLevelQuery(parent, productQuery) {
			if (this.srMaster) {
				const masterToProductHierarchyMap = {
					"SRMCollection": "Collection",
					"SRMCategory2": "Category2",
					"SRMCategory1": "Category1",
					"SRMSeason": "ParentSeason"
				};

				const parentStructureItem = Object.entries(masterToProductHierarchyMap)
					.find(([key, value]) => xml.isValidURL(this.srMaster[key]));

				if (parentStructureItem) {
					const productHierarchyLevelAttr = parentStructureItem[1];
					const srMasterHierarchyLevelAttr = parentStructureItem[0];
					productQuery.RefAttr(productHierarchyLevelAttr, xml.OP_EQUALS, this.srMaster[srMasterHierarchyLevelAttr]);
				}
			} else {
				this.inherited(arguments);
			}
		},

		/**
		 * @override
		 * Disable UpdateExistingSupplierRequests field, set value to false and hide it
		 */
		disableUpdateExistingSR() {
			const updateSRsField = this.getField(this.UPDATE_EXISTING_SUPPLIER_REQUESTS);
			if (this._isFieldActive(updateSRsField)) {
				this.setFieldDisabled(updateSRsField, true);
				this.updateExistingSupplierRequestsEnabledValue = this.getFieldValue(updateSRsField);
				this.setFieldValue(updateSRsField, false);
			}
		},

		/**
		 * @override
		 * Set SRMaster field to hidden by default if not being created inside a SRMaster
		 * @param {String} rel - Relationship name
		 * @returns {Object} productStoreOptions
		 */
		getProductStoreOptions(rel) {
			let productStore;
			const productType = this._productType();
			const ac = this.defView.getSource();
			const parent = ac.getParent() || ac.getNode();
			// Priority Store for Style/Material Field in SR form created in SRM
			if (productType === this.STYLE || productType === this.MATERIAL) {
				let priorityStore;
				// Set SRMaster when creating Allocated SRs outside of SRM
				if (this.srMaster == null && this.isFieldVisible("SRMaster")) {
					const srMasterFieldValue = this.getFieldValue("SRMaster");
					this.srMaster = this.cacheView.getNode(srMasterFieldValue);
				}
				// Create Priority Store for SRMProducts if action is from inside a SRM or creating SR under an existing SRM 
				if (this.srMaster?.SRMProducts.length) {
					priorityStore = this.getPriorityStoreForSRM_SRMProducts(productType, parent.$Type, parent.$URL);
				}
				const priorityStoreExists = priorityStore ? true : false;
				productStore = new Names({
					priorityStore: priorityStore,
					treatAsPriority: priorityStoreExists,
				});
			}
			return csiStore.namesOptionsByRelationship(this.getContext(), rel, productStore);
		},

		/**
		 * Priority Store if SRM has SRMProducts
		 * @param {String} productType - Style or Material
		 * @param {String} parentType - Parent node type
		 * @param {String} parentURL - Parent node URL
		 */
		getPriorityStoreForSRM_SRMProducts(productType, parentType, parentURL) {
			const subtypeFieldValue = this.getFieldValue(this.SUBTYPE);
			const creationLevel = config.getSubtypeSetting(subtypeFieldValue, this.PRODUCT_SOURCE_CREATION_LEVEL);
			let search = new Search();
			search.setLimitPath(this.srMaster.$URL, "Child:SRMProducts");
			search.getQuery().Node("Type", "EQ", productType);
			if (parentType == "MaterialSecurityGroup") {
				search.getQuery().RefAttr("MaterialSecurityGroups", xml.OP_EQUALS, parentURL);
			}
			if (creationLevel) {
				search.getQuery().Attr(this.PRODUCT_SOURCE_CREATION_LEVEL, xml.OP_EQUALS, creationLevel, "Child:ProductType/Child:ProductionConfig");
			}
			search.getSortQuery().SortByNode(xml.PROP_NAME);
			priorityStore = new Names({
				request: search.getRequest(),
			});
			return priorityStore;
		},
	});
});
